import { CONTROL_BUCKET, TREATMENT_BUCKET, IDENTIFIER_USERID } from './experiment-defaults';

const BUCKETS = [CONTROL_BUCKET, TREATMENT_BUCKET];
const IDENTIFIER = IDENTIFIER_USERID;
const NAME = 'car-stc-vehicle-ownership-signals';

export { BUCKETS, CONTROL_BUCKET, TREATMENT_BUCKET, IDENTIFIER, NAME };
